module.exports = __webpack_public_path__ + "static/img/andy-g-jones-head@2x.54a48ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/andy-g-jones-head@2x.png
// module id = hoF+
// module chunks = 13